import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { Button } from '@estee/elc-buttons';
import { Form } from '@estee/elc-form';
import { Heading3 } from '@estee/elc-typography';

import { EmailInput } from '~components/EmailInput';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import {
    formClassName,
    formSubtitleClassName,
    formTitleClassName,
    formWrapperClassName
} from '~utils/Classes';
import { useTranslation } from '~utils/hooks/translations';
import { MessagePanel } from '~views/common/MessagePanel';

import { EmailFormViewController } from './EmailFormViewController';

const LinkButton = styled.a<{ disabled: boolean }>`
    cursor: pointer;
    margin-block-start: 24px;
    ${({ disabled }) => disabled && 'pointer-events: none;'};
`;

export const EmailForm = observer(() => {
    const {
        data: { formStore, emailValidations, errorMessages, resetView },
        sendEmailButtonClicked,
        load
    }: EmailFormViewController = diContainer.get(serviceNames.emailFormViewController);

    React.useEffect(() => {
        load();
    }, []);

    const {
        enterEmailOtpInstructions,
        enterYourEmailAddress,
        continueLabel,
        goBack,
        emailLabel,
        loadingLabel
    } = useTranslation();

    const { isSubmitting } = formStore;

    return (
        <div className={formWrapperClassName}>
            <MessagePanel messages={errorMessages} />
            <Heading3 className={formTitleClassName}>{enterYourEmailAddress}</Heading3>
            <p className={formSubtitleClassName}>{enterEmailOtpInstructions}</p>
            <div className={formClassName}>
                <Form
                    store={formStore}
                    render={() => (
                        <EmailInput
                            formStore={formStore}
                            showDomainSuggestionList={false}
                            name="emailAddress"
                            inputLabel={emailLabel}
                            inputType={'email'}
                            fieldValidations={emailValidations}
                            isAutoCompleteDisabled
                        />
                    )}
                />
            </div>
            <Button disabled={isSubmitting} onClick={sendEmailButtonClicked}>
                {isSubmitting ? loadingLabel : continueLabel}
            </Button>
            <LinkButton aria-label={goBack} disabled={isSubmitting} onClick={resetView}>
                {goBack}
            </LinkButton>
        </div>
    );
});
